import { create } from "zustand";
import {
  getCoachTipList,
  getDietPlanList,
  getHomePageTagLineList,
  getReorderKitList,
  getRootCauseList,
  getRootCauseSectionList,
  getTaskListData,
  getTrayaDoctorList,
  getUserReviewList,
  getWelcomeVideoList,
  getdraftHeaderDataList,
  putCoachTipList,
  putDietPlanList,
  putDraftHeaderDataList,
  putHomePageTagLineList,
  putReorderKitList,
  putRootCauseList,
  putRootCauseSectionList,
  putTaskList,
  putTrayaDoctorList,
  putUserReviewList,
  putWelcomeVideoList,
} from "../api";

export const useTaskList = create((set) => ({
  taskListData: [],
  isLoading: false,
  isError: false,
  errorMessage: "",
  fetchTaskList: async () => {
    set({ errorMessage: "", isError: false });
    set({ isLoading: true });
    try {
      const response = await getTaskListData();
      set({ taskListData: response.data, isLoading: false });
    } catch (error) {
      set({
        errorMessage: error?.response?.data?.Error,
        isError: true,
        isLoading: false,
      });
    }
  },
}));

export const userCoachTipList = create((set) => ({
  coachTipListData: [],
  isLoading: false,
  isError: false,
  errorMessage: "",
  fetchCoachTipList: async () => {
    set({ errorMessage: "", isError: false });
    set({ isLoading: true });
    try {
      const response = await getCoachTipList();
      set({ coachTipListData: response.data, isLoading: false });
    } catch (error) {
      set({
        errorMessage: error?.response?.data?.Error,
        isError: true,
        isLoading: false,
      });
    }
  },
}));

export const useDietPlanList = create((set) => ({
  dietPlanListData: [],
  isLoading: false,
  isError: false,
  errorMessage: "",
  fetchDietPlanList: async () => {
    set({ errorMessage: "", isError: false });
    set({ isLoading: true });
    try {
      const response = await getDietPlanList();
      set({ dietPlanListData: response.data, isLoading: false });
    } catch (error) {
      set({
        errorMessage: error?.response?.data?.Error,
        isError: true,
        isLoading: false,
      });
    }
  },
}));

export const useHomePageTagLineList = create((set) => ({
  homePageTagLineListData: [],
  isLoading: false,
  isError: false,
  errorMessage: "",
  fetchHomePageTagLineList: async () => {
    set({ errorMessage: "", isError: false });
    set({ isLoading: true });
    try {
      const response = await getHomePageTagLineList();
      set({ homePageTagLineListData: response.data, isLoading: false });
    } catch (error) {
      set({
        errorMessage: error?.response?.data?.Error,
        isError: true,
        isLoading: false,
      });
    }
  },
}));

export const useReorderKitList = create((set) => ({
  reorderKitListData: [],
  isLoading: false,
  isError: false,
  errorMessage: "",
  fetchReorderKitListData: async () => {
    set({ errorMessage: "", isError: false });
    set({ isLoading: true });
    try {
      const response = await getReorderKitList();
      set({ reorderKitListData: response.data, isLoading: false });
    } catch (error) {
      set({
        errorMessage: error?.response?.data?.Error,
        isError: true,
        isLoading: false,
      });
    }
  },
}));

export const useRootCauseList = create((set) => ({
  rootCauseListData: [],
  isLoading: false,
  isError: false,
  errorMessage: "",
  fetchRootCauseListData: async () => {
    set({ errorMessage: "", isError: false });
    set({ isLoading: true });
    try {
      const response = await getRootCauseList();
      set({ rootCauseListData: response.data, isLoading: false });
    } catch (error) {
      set({
        errorMessage: error?.response?.data?.Error,
        isError: true,
        isLoading: false,
      });
    }
  },
}));

export const useRootCauseSectionList = create((set) => ({
  rootCauseSectionListData: [],
  isLoading: false,
  isError: false,
  errorMessage: "",
  fetchRootCauseSectionListData: async () => {
    set({ errorMessage: "", isError: false });
    set({ isLoading: true });
    try {
      const response = await getRootCauseSectionList();
      set({ rootCauseSectionListData: response.data, isLoading: false });
    } catch (error) {
      set({
        errorMessage: error?.response?.data?.Error,
        isError: true,
        isLoading: false,
      });
    }
  },
}));

export const useTrayaDoctorList = create((set) => ({
  trayaDoctorListData: [],
  isLoading: false,
  isError: false,
  errorMessage: "",
  fetchTrayaDoctorListData: async () => {
    set({ errorMessage: "", isError: false });
    set({ isLoading: true });
    try {
      const response = await getTrayaDoctorList();
      set({ trayaDoctorListData: response.data, isLoading: false });
    } catch (error) {
      set({
        errorMessage: error?.response?.data?.Error,
        isError: true,
        isLoading: false,
      });
    }
  },
}));

export const useDraftHeaderList = create((set) => ({
  draftHeaderListData: [],
  isLoading: false,
  isError: false,
  errorMessage: "",
  fetchDraftHeaderListData: async () => {
    set({ errorMessage: "", isError: false });
    set({ isLoading: true });
    try {
      const response = await getdraftHeaderDataList();
      set({ draftHeaderListData: response.data, isLoading: false });
    } catch (error) {
      set({
        errorMessage: error?.response?.data?.Error,
        isError: true,
        isLoading: false,
      });
    }
  },
}));

export const useReviewList = create((set) => ({
  reviewListData: [],
  isLoading: false,
  isError: false,
  errorMessage: "",
  fetchReviewListData: async () => {
    set({ errorMessage: "", isError: false });
    set({ isLoading: true });
    try {
      const response = await getUserReviewList();
      set({ reviewListData: response.data, isLoading: false });
    } catch (error) {
      set({
        errorMessage: error?.response?.data?.Error,
        isError: true,
        isLoading: false,
      });
    }
  },
}));

export const useWelcomeVideoList = create((set) => ({
  welcomeVideoListData: [],
  isLoading: false,
  isError: false,
  errorMessage: "",
  fetchWelcomeVideoListData: async () => {
    set({ errorMessage: "", isError: false });
    set({ isLoading: true });
    try {
      const response = await getWelcomeVideoList();
      set({ welcomeVideoListData: response.data, isLoading: false });
    } catch (error) {
      set({
        errorMessage: error?.response?.data?.Error,
        isError: true,
        isLoading: false,
      });
    }
  },
}));

export const usePutTaskList = create((set) => ({
  isLoading: false,
  isError: false,
  errorMessage: "",
  updateTaskList: async (data, id, setToaster) => {
    set({ errorMessage: "", isError: false });
    set({ isLoading: true });
    setToaster("Update Task List", "List upadted successfully", "success");
    try {
      await putTaskList(data, id);
    } catch (error) {
      set({
        errorMessage: error?.response?.data?.Error,
        isError: true,
        isLoading: false,
      });
    }
  },
}));

export const usePutCoachTipList = create((set) => ({
  isLoading: false,
  isError: false,
  errorMessage: "",
  updateCoachTipList: async (data, id, setToaster) => {
    set({ errorMessage: "", isError: false });
    set({ isLoading: true });
    setToaster("Update Coach Tip List", "List upadted successfully", "success");
    try {
      await putCoachTipList(data, id);
    } catch (error) {
      set({
        errorMessage: error?.response?.data?.Error,
        isError: true,
        isLoading: false,
      });
    }
  },
}));

export const usePutDietPlanList = create((set) => ({
  isLoading: false,
  isError: false,
  errorMessage: "",
  updateDietPlanList: async (data, id, setToaster) => {
    set({ errorMessage: "", isError: false });
    set({ isLoading: true });
    try {
      await putDietPlanList(data, id);
      setToaster("Update Deit Plan List", "List upadted successfully", "success");
    } catch (error) {
      set({
        errorMessage: error?.response?.data?.Error,
        isError: true,
        isLoading: false,
      });
    }
  },
}));

export const usePutHomePageTagLineList = create((set) => ({
  isLoading: false,
  isError: false,
  errorMessage: "",
  updateHomePageTagLineList: async (data, id, setToaster) => {
    
    set({ errorMessage: "", isError: false });
    set({ isLoading: true });
    try {
      await putHomePageTagLineList(data, id);
      setToaster("Update Homepage Tagline List", "List upadted successfully", "success");
    } catch (error) {
      set({
        errorMessage: error?.response?.data?.Error,
        isError: true,
        isLoading: false,
      });
    }
  },
}));

export const usePutRootCauseList = create((set) => ({
  isLoading: false,
  isError: false,
  errorMessage: "",
  updatePutRootCauseList: async (data, id, setToaster) => {
    
    set({ errorMessage: "", isError: false });
    set({ isLoading: true });
    try {
      await putRootCauseList(data, id);
      setToaster("Update Homepage Tagline List", "List upadted successfully", "success");
    } catch (error) {
      set({
        errorMessage: error?.response?.data?.Error,
        isError: true,
        isLoading: false,
      });
    }
  },
}));

export const usePutReorderKitList = create((set) => ({
  isLoading: false,
  isError: false,
  errorMessage: "",
  updatePutReorderKitList: async (data, id, setToaster) => {
    
    set({ errorMessage: "", isError: false });
    set({ isLoading: true });
    try {
      await putReorderKitList(data, id);
      setToaster("Update Reorder Kit List", "List upadted successfully", "success");
    } catch (error) {
      set({
        errorMessage: error?.response?.data?.Error,
        isError: true,
        isLoading: false,
      });
    }
  },
}));

export const usePutRootCauseSectionList = create((set) => ({
  isLoading: false,
  isError: false,
  errorMessage: "",
  updateRootCauseSectionList: async (data, id, setToaster) => {
    
    set({ errorMessage: "", isError: false });
    set({ isLoading: true });
    try {
      await putRootCauseSectionList(data, id);
      setToaster("Update Root Cause Section List", "List upadted successfully", "success");
    } catch (error) {
      set({
        errorMessage: error?.response?.data?.Error,
        isError: true,
        isLoading: false,
      });
    }
  },
}));

export const usePutTrayaDoctorList = create((set) => ({
  isLoading: false,
  isError: false,
  errorMessage: "",
  updateTrayaDoctorList: async (data, id, setToaster) => {
    
    set({ errorMessage: "", isError: false });
    set({ isLoading: true });
    try {
      await putTrayaDoctorList(data, id);
      setToaster("Update Traya Doctor List", "List upadted successfully", "success");
    } catch (error) {
      set({
        errorMessage: error?.response?.data?.Error,
        isError: true,
        isLoading: false,
      });
    }
  },
}));

export const usePutDraftHeaderDataList = create((set) => ({
  isLoading: false,
  isError: false,
  errorMessage: "",
  updateDraftHeaderDataList: async (data, id, setToaster) => {
    
    set({ errorMessage: "", isError: false });
    set({ isLoading: true });
    try {
      await putDraftHeaderDataList(data, id);
      setToaster("Update Draft Header Data List", "List upadted successfully", "success");
    } catch (error) {
      set({
        errorMessage: error?.response?.data?.Error,
        isError: true,
        isLoading: false,
      });
    }
  },
}));

export const usePutWelcomeVideoList = create((set) => ({
  isLoading: false,
  isError: false,
  errorMessage: "",
  updateWelcomeVideoList: async (data, id, setToaster) => {
    
    set({ errorMessage: "", isError: false });
    set({ isLoading: true });
    try {
      await putWelcomeVideoList(data, id);
      setToaster("Update Welcome video List", "List upadted successfully", "success");
    } catch (error) {
      set({
        errorMessage: error?.response?.data?.Error,
        isError: true,
        isLoading: false,
      });
    }
  },
}));

export const usePutUserReviewList = create((set) => ({
  isLoading: false,
  isError: false,
  errorMessage: "",
  updateUserReviewList: async (data, id, setToaster) => {
    
    set({ errorMessage: "", isError: false });
    set({ isLoading: true });
    try {
      await putUserReviewList(data, id);
      setToaster("Update User Review List", "List upadted successfully", "success");
    } catch (error) {
      set({
        errorMessage: error?.response?.data?.Error,
        isError: true,
        isLoading: false,
      });
    }
  },
}));